import ApplicationController from './application_controller';

export default class extends ApplicationController {
  dismiss(event) {
    event.preventDefault();

    // eslint-disable-next-line no-alert, no-restricted-globals
    if (!confirm("Are you sure you want to dismiss this notification? You won't see it again.")) {
      return;
    }

    const { notificationId } = this.element.dataset;
    fetch(`/global-notifications/${notificationId}/dismiss`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          this.element.remove();
        } else {
          console.error('Failed to dismiss notification:', data.errors);
        }
      })
      .catch((error) => console.error('Error:', error));
  }
}
